import { NextPage } from "next";
import { getGlobals } from "@models/globals.model";
import { Sanity } from "@models/sanity.model";
import AccountAuth from "@components/account-auth";
import { AccountGlobalSchema, getUserAccountGlobals } from "@models/user-account-globals";

export interface OrdersPageProps extends Sanity.PageProps {
  accountGlobals: AccountGlobalSchema;
}

const OrdersPage: NextPage<OrdersPageProps> = ({ globals, accountGlobals }) => {
  return (
    <AccountAuth
      globals={globals}
      accountGlobals={accountGlobals}
      pageID="order-history"
      seo={{ title: "Account | Information" }}
    />
  );
};

export default OrdersPage;

export async function getStaticProps() {
  const [globals, accountGlobals] = await Promise.all([
    await getGlobals(),
    await getUserAccountGlobals(),
  ]);

  return {
    props: {
      globals,
      accountGlobals,
    },
  };
}
